import * as ACTION_TYPES from '../types';

let initialState = {
  checklistList: [],
  checklist: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_CHECKLISTS:
        return {...state, checklistList: action.data };

      case ACTION_TYPES.DELETE_CHECKLIST:
        let newList = state.checklistList.filter(checklist => checklist._id !== action.id);
        return {...state, checklistList: newList };

      case ACTION_TYPES.GET_CHECKLIST_BY_ID:
        return {...state, checklist: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_CHECKLISTS:
        return {...state, checklistList: []};

      default:
        return state;
    }
  };